const data = {
  primeBottle1: [30, 145],
  // primeBottle1: [0, 1400],
  primeBottle2: [172, 307],
  primeBottle3: [314, 422],
  // dropSize1: [448, 715],
  dropSize1: [448, 869],
  // dropSize2: [715, 869],
  // blinkReflex1: [869, 932],
  blinkReflex1: [869, 996],
  // blinkReflex2: [932, 996],
  // blinkReflex2: [932, 1492],
  blinkReflex3: [1052, 1400],
};
// const data = {
//   primeBottle1: [0, 172],
//   // primeBottle1: [0, 1192],
//   primeBottle2: [172, 314],
//   primeBottle3: [314, 448],
//   dropSize1: [448, 715],
//   dropSize2: [715, 869],
//   blinkReflex1: [869, 932],
//   blinkReflex2: [932, 996],
//   blinkReflex3: [1052, 1192],
// };

export default data;
